<template>
  <div class="wrapW team">
    <div class="titleD">
      <div class="titleDT">{{slaveTitleX}}</div>
      <div>
        <h4 class="titlex">{{slaveTitle}}</h4>
        <h2 class="title">{{title}}</h2>
      </div>
    </div>
    <div class="xian"></div>
    <div class="center" v-if="list[0]">
      <div class="img"><img :src="list[A].img"></div>
      <div class="right">
        <div class="name">{{list[A].position}}-{{list[A].name}}</div>
        <div class="department">{{list[A].department}}</div>
        <div class="desc hidden_tetx_four" v-html="list[A].desc"></div>
        <div class="button">
          <div class="swiper-button-prev ip1 iconfont icon-zuojiantou" :class="{'hui':A == 0}" slot="button-prev" @click="jia(1)"></div>
          <div class="swiper-button-next ip1 iconfont icon-youjiantou" :class="{'hui':A == list.length -1}" slot="button-next" @click="jia(2)"></div>
        </div>
        <swiper :options="swiperOption" class="banner_list" ref="swiperTop">
          <swiper-slide v-for="(i,index) in list" :key="index">
            <div class="swiperL" ref="body" :class="{action:A == index}">
              <img :src="i.img" @click="A=index">
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'team',
  data () {
    return {
      A: 0,
      swiperOption: {
        loop: false,
        spaceBetween:10,
        slidesPerView: 5.8,
        autoplay: false,
        nextButton: '.swiper-button-next.ip2',
        prevButton: '.swiper-button-prev.ip2',
      },
      list: [],
      title: '',
      slaveTitleX: '',
      slaveTitle: '',
      introduce: '',
      A: 0,
      left: 0
    }
  },
  mounted () {
    this.getTeam()
    
  },
  methods: {
    jia (type) {
      if (type == 1) {
        if (this.A > 0) {
          this.A--
          
        } else {
          // this.A = this.list.length - 1
        }
      } else {
        // this.A++
        if (this.A < this.list.length - 1) {
          // this.num++
          this.A++
        } else {
          // this.A = 0
          // this.num = 0
        }
      }
      this.$refs.swiperTop.swiper.activeIndex = this.A
      console.log(this.A)
      console.log('-------------------')
    },
    getTeam () {
      let that = this
      this.$axios.get(process.env.API_HOSTT + '/os/getTeam', {
      }).then(
        function (res) {
          res = res.data.data
          that.list = res.list
          that.title = res.introduce.title
          that.slaveTitle = res.introduce.slaveTitle.substr(1)
          that.slaveTitleX = res.introduce.slaveTitle.substr(0,1)
          that.introduce = res.introduce.desc          
        }
      ).catch(error => console.log(error))
    }
  }
}
</script>
<style lang="stylus" scoped>
.team
  width 80%
  max-width 1200px
  min-width 800px
  margin 0 auto
  margin-top .6rem
  padding-bottom .73rem
  .center
    display flex
    padding-bottom 1rem
    overflow hidden
    .img
      padding .1rem
      height 4.2rem
      box-shadow 0px 0px 12px 0px rgba(9, 9, 9, 0.22)
      img
        height 100%
    .right
      margin-left .1rem
      text-align left
      position relative
      flex auto
      overflow hidden
      padding-left .2rem
      .name
        color var(--hei)
        font-size .24rem
        font-weight 400
        line-height .52rem
      .department
        color #D5A14E
        font-size .18rem
        margin-bottom .16rem
        line-height .38rem
        font-weight bold
      .desc
        color #666
        font-size .16rem
        line-height .24rem
        margin-bottom .2rem
        padding-right .72rem
        // height .96rem
      .contact
        position absolute
        top 0px
        right 1.95rem
        font-size .22rem
        display flex
        div
          height .24rem
          line-height .24rem
          padding 0 .1rem
      .button
        display flex
        height .4rem
        .swiper-button-prev,.swiper-button-next
          width .4rem
          height .4rem
          border-radius 50%
          font-size .18rem
          font-weight bold
          line-height .4rem
          text-align center
          margin-right .23rem
          background #fff
          color #d5a14e
          border 1px solid #DCDCDC
          position unset
          margin-top 0
        .ip1:hover
          background #d5a14e
          color #fff
          border 0px
        .swiper-button-prev
          background-image none
        .swiper-button-next
          background-image none
        .swiper-container
          overflow initial
      .banner_list
        width 100%
        display flex
        margin-top .15rem
        justify-content space-between
        padding .1rem
        margin-left -.2rem
        .swiperL
          background #fff
          text-align center
          height 1.42rem
          padding .08rem
          margin-right .3rem
          width 100%
          img
            width 100%
            height 100%
            object-fit cover
        .swiperL.action
          box-shadow 0px 0px 12px 0px rgba(9, 9, 9, 0.22)
      .hui
        opacity .2
</style>



// WEBPACK FOOTER //
// src/pages/index/components/team.vue